/* eslint-disable */
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Button, Input, InputCheckbox, LoadingSpinner, SearchableSelect, InlineAlert } from '../components/BaseComponents'
import routes from '../components/Router/routes'
import PageHeadings from '../components/BaseComponents/PageHeadings/PageHeadings'
import { useAppDispatch, useAppSelector } from '../redux/hooks/reduxHooks'
import Modal from '../components/BaseComponents/Modal/Modal'
import { FetchStatus, PostStatus } from '../types/LoadingStates'
import PageTemplate from '../components/BaseComponents/PageTemplate/PageTemplate'
import { getCompanyList } from '../redux/actions/getCompanyListActions'
import { selectCompanyList, selectCompanyListStatus } from '../redux/slices/getCompanyListSlice'
import { createInvitation, getInvitations } from '../redux/actions/invitationsActions'
import {
	INVITATIONS_CREATE_RESET,
	selectCreateInvitationsStatus,
} from '../redux/slices/createInvitationsSlice'
import {
	selectInvicationsError,
	selectInvitations,
	selectInvitationsStatus,
} from '../redux/slices/invitationsSlice'
import InvitationsTable from '../components/InvitationsTable/InvitationsTable'
import { getRoles } from '../redux/actions/rolesActions'
import { selectRoles, selectRolesStatus } from '../redux/slices/rolesSlice'
import { validateEmail } from '../lib/utils'
import { SelectDropdown } from '../types/SelectDropdown'
import useApi from '../hooks/useApi'

function AdminInviteUser() {
	const [email, setEmail] = useState('')
	const [companyId, setCompanyId] = useState('')
	const [sendEmail, setsendEmail] = useState<boolean | undefined>(false)
	const [companyList, setcompanyList] = useState<Array<SelectDropdown>>([])
	const [valid, setValid] = useState<boolean>(true)
	const [validCompany, setValidcompany] = useState<boolean>(true)

	const dispatch = useAppDispatch()
	const api = useApi();

	const createInvitationStatus = useAppSelector(selectCreateInvitationsStatus)
	const allInvitations = useAppSelector(selectInvitations)
	const invitationsStatus = useAppSelector(selectInvitationsStatus)
	const invitationsError = useAppSelector(selectInvicationsError)

	const companyListStatus = useAppSelector(selectCompanyListStatus)
	const companylistsData = useAppSelector(selectCompanyList)

	const roleStatus = useAppSelector(selectRolesStatus)
	const rolesData = useAppSelector(selectRoles)

	const [inviteUserModalOpen, setInviteUserModalOpen] = useState<boolean>(false)
	useEffect(() => {
		dispatch(getCompanyList(api, { limit: 1000 }))
		dispatch(getInvitations(api))
		dispatch(getRoles(api))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (companyListStatus === FetchStatus.loaded) {
			let buildList = []
			for (let i = 0; i < companylistsData.length; i++) {
				buildList.push({ label: companylistsData[i].name, value: companylistsData[i].id })
			}
			setcompanyList(buildList)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyListStatus])

	// Invitations from this page are always organisation (company-role) invitations.
	const companyRoleId = rolesData.find((role) => role.name === 'company')?.id

	const resetInvitation = () => {
		dispatch({
			type: INVITATIONS_CREATE_RESET,
		})
		// Reset local state stores used in form
		setEmail('')
		setCompanyId('')
		setsendEmail(false)
		setValid(true)
		setValidcompany(true)
	}

	const submitInvitation = () => {
		if (!validateEmail(email)) {
			setValid(false)
		} else if (!companyId) {
			setValidcompany(false)
		} else if (sendEmail !== undefined && companyRoleId) {
			dispatch(createInvitation(api, companyId, email, sendEmail, companyRoleId))
		}
	}

	return (
		<PageTemplate testid='add-accounting-periods-main'>
			<Helmet>
				<title>{routes.adminInviteUser.name}</title>
			</Helmet>
			<PageHeadings title='Invite User' />

			<div className='block'>
				<Button
					type='Primary'
					text='Invite a New User'
					size='sm'
					hasTrailingIcon
					icon='fa-solid fa-plus'
					onClick={() => {
						setInviteUserModalOpen(true)
					}}
					additionalClass='mt-4 mb-2'
				/>
				<Modal
					open={inviteUserModalOpen}
					onOpen={() => resetInvitation()}
					onClose={() => setInviteUserModalOpen(false)}
					size='small'
				>
					{createInvitationStatus === PostStatus.initial && (
						<>
							<PageHeadings title='Invite a new User' />

							<div className='max-w-2xl'>
								<Input
									label='Email'
									type='text'
									name='email'
									value={email}
									onChange={(e) => {
										setEmail(e.target.value)
									}}
									additionalClass='mt-2'
								/>
								{!valid && (
									<InlineAlert type='error' className='mb-4 mt-4'>										<p className='text-white'>You must enter a valid email address</p>
									</InlineAlert>
								)}
								<>
										<label
											htmlFor='Company'
											className='block text-sm text-charcoal-100 mt-2'
										>
											Organisation
										</label>
									<SearchableSelect
										name='Company'
										options={companyList}
										isMulti={false}
										isSearchable={true}
										isClearable={false}
										fillContainer
										onChange={(value) => {
											if (value?.value !== undefined) {
												setCompanyId(value.value)
											}
										}}
										value={companyList.find((option) => option.value === companyId) ?? null}
									/>
										{!validCompany && (
											<InlineAlert type='error' className='mb-4 mt-4'>												<p className='text-white'>You must select a organisation.</p>
											</InlineAlert>
										)}
								</>
								<div className='text-charcoal-100 text-sm mt-4'>
									<label>
										Send Email
										<InputCheckbox
											className='mx-4'
											checked={sendEmail}
											onChange={(e) => {
												setsendEmail(!sendEmail)
											}}
										/>
									</label>
								</div>
							</div>

							<Button
								onClick={submitInvitation}
								type='Primary'
								hasTrailingIcon={true}
								icon='fa-solid fa-plus'
								text='Invite User'
								additionalClass='mt-9 mr-5'
							/>
							<Button
								type='Outlined'
								text='Cancel'
								onClick={() => {
									setInviteUserModalOpen(!inviteUserModalOpen)
								}}
							/>
						</>
					)}
					{createInvitationStatus === PostStatus.sending && (
						<LoadingSpinner loadingText='Inviting User...' />
					)}

					{createInvitationStatus === PostStatus.sent && (
						<>
							<PageHeadings title='Successfully invited the user' />
							<p className='text-white mt-6'>Your new user has been invited successfully:</p>

							<div className='mt-4 bg-white rounded-lg p-4'>
								<p className='text-lg'>
									<strong>Email:</strong>
								</p>
								<p>{email}</p>
								<p className='mt-4 text-lg'>
									<strong>Organisation:</strong>
								</p>
								<p>{companyList.filter((item: any) => item.value === companyId)[0]?.label}</p>

								<p className='mt-4 text-lg'>
									<strong>Send Email?:</strong>
								</p>
								<p>{sendEmail === true ? 'Yes' : 'No'}</p>
							</div>

							<Button
								type='Primary'
								text='Back to user list'
								onClick={() => {
									resetInvitation()
									setInviteUserModalOpen(false)
								}}
								additionalClass='mt-6 mr-5'
							/>

							<Button
								type='Outlined'
								text='Invite another user'
								icon='fa-solid fa-plus'
								hasTrailingIcon
								onClick={() => {
									resetInvitation()
								}}
								additionalClass='mt-6'
							/>
						</>
					)}

					{createInvitationStatus === PostStatus.error && (
						<>
							<PageHeadings title='Error' />
							<InlineAlert type='error' className='mt-4'>								<p className='text-white'>
									There was an error whilst trying to invite the user. If this problem persists,
									please contact the Neoni team.
								</p>
							</InlineAlert>
							<Button
								onClick={submitInvitation}
								type='Primary'
								hasTrailingIcon={true}
								icon='fa-solid fa-arrow-right'
								text='Retry'
								additionalClass='mt-9 mr-5'
							/>
							<Button
								type='Outlined'
								text='Cancel'
								onClick={() => {
									setInviteUserModalOpen(false)
								}}
								additionalClass='mt-6 mr-5'
							/>
						</>
					)}
				</Modal>
			</div>

			<div className='flex-grow mt-4 '>
				<div className='col-span-2 w-full'>
					<div className='block rounded-lg bg-charcoal-600'>
						<div className='flex flex-col pt-xl pb-2'>
							{invitationsStatus === FetchStatus.loading && <LoadingSpinner />}

							{invitationsStatus === FetchStatus.loaded && allInvitations.length > 0 && (
								<InvitationsTable invitations={allInvitations} type='Admin' />
							)}

							{invitationsStatus === FetchStatus.loaded && allInvitations.length === 0 && (
								<>
									<p className='text-white px-4 py-2'>We did not find any invitations.</p>
								</>
							)}

							{invitationsStatus === FetchStatus.error && (
								<>
									<p className='my-lg text-white'>
										Oops! There was an error fetching the invitations data.
									</p>
									<p className='my-lg mt-4 text-white'>{invitationsError}</p>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</PageTemplate>
	)
}
export default AdminInviteUser
